"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { BootButton, CloseButton } from 'generics/buttons';
import { IconGlyphicon, IconFontAwesome } from 'generics/icons';

import spawnConfirmSellModal from 'components/confirmSellDialog';
import {  BriefBookLoader  } from 'components/briefBookLoader';
import { spawnDialogWindow } from 'components/dialogHolder';


export default class ViewQuickSellDialog extends React.Component  {
  constructor(props)  {
    super(props);

    this.onUpdateBriefBook = (resp)  =>  this.gotOrderbook(resp);
    this.completed = false;
  }


  static spawnQuickSellModal( appid,  ctxid,  asssid,  market_name,  classInfo )  {
    if ( (!classInfo.marketable)  || (!asssid) )
      return;

    spawnDialogWindow(ViewQuickSellDialog,  {
        appid,  ctxid,  asssid,  market_name,  classInfo,
      });
  }


  onBackdropTouch()  {
    // It's can't be closed, must wait till completion
    // this.props.removeModal();
  }


  gotOrderbook(  book  )  {
    if ( this.completed )
      return;
    this.completed = true;

    const {  appid,  ctxid,  asssid  } = this.props;
    const {  market_name,  classInfo  } = this.props;

    const startBuyPrice  = (book.ordersBuy  || [])[0];
    const startSellPrice = (book.ordersSell || [])[0];

    const initialSellPrice = (startBuyPrice  || startSellPrice || {}).price;

    const haveOwnOrders = false;

    spawnConfirmSellModal(  appid,  ctxid,  asssid,
                                                  market_name,  classInfo,
                                                  initialSellPrice,  haveOwnOrders );

    this.props.removeModal(); // close self
  }


  render()  {
    return (
        <div className="panel panel-info panel-sm view-quick-sell-dialog">
          <div className="panel-heading">
            Please wait...
          </div>

          <div className="panel-body">
            <div className="text-center">
              <IconFontAwesome type="spinner" size="3x" pulse fixedWidth />&nbsp;
            </div>
            <div className="text-center">
              <h4>Actualizing orderbook info, please wait.</h4>
            </div>
            <BriefBookLoader  onUpdate={this.onUpdateBriefBook}
                              market_name={this.props.market_name}
                              appid={this.props.appid}
                            />
          </div>
        </div>
      );
  }


}
